(function () {
  'use strict';

  var instances = {};

  function getVideo(card) {
    return card && card.querySelector('video');
  }

  function pauseCard(card) {
    if (!card) {
      return;
    }
    var v = getVideo(card);
    if (v && !v.paused) {
      v.pause();
    }
    card.classList.remove('is-playing');
  }

  function pauseAllExcept(cards, exceptCard) {
    cards.forEach(function (card) {
      if (card !== exceptCard) {
        pauseCard(card);
      }
    });
  }

  function playCard(state, card) {
    var v = getVideo(card);
    if (!v) {
      return;
    }
    pauseAllExcept(state.cards, card);
    var playPromise = v.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {
        /* Playback can still fail (e.g. missing source); the card remains tappable to retry. */
      });
    }
    card.classList.add('is-playing');
  }

  function togglePlay(state, card) {
    var v = getVideo(card);
    if (!v) {
      return;
    }
    if (v.paused) {
      playCard(state, card);
    } else {
      pauseCard(card);
    }
  }

  function setCurrent(state, index) {
    if (index === state.current) {
      return;
    }
    state.current = index;
    state.cards.forEach(function (card, i) {
      card.classList.toggle('is-current', i === index);
    });
    if (state.counterCurrent) {
      state.counterCurrent.textContent = String(index + 1);
    }
  }

  function scrollStep(state) {
    var firstCard = state.cards[0];
    if (!firstCard) {
      return 0;
    }
    var trackStyles = window.getComputedStyle(state.track);
    var gap = parseFloat(trackStyles.columnGap || trackStyles.gap || '0') || 0;
    return firstCard.offsetWidth + gap;
  }

  function go(state, delta) {
    if (!state.viewport) {
      return;
    }
    var step = scrollStep(state);
    state.viewport.scrollBy({ left: delta * step, behavior: 'smooth' });
  }

  function init(rootId) {
    var root = document.getElementById(rootId);
    if (!root || instances[rootId]) {
      return;
    }

    var cards = Array.prototype.slice.call(root.querySelectorAll('.influencer-card'));
    if (!cards.length) {
      return;
    }

    var state = {
      root: root,
      cards: cards,
      current: 0,
      viewport: root.querySelector('.influencer-carousel__viewport'),
      track: root.querySelector('.influencer-carousel__track'),
      counterCurrent: root.querySelector('.influencer-carousel__counter-current')
    };

    var prevBtn = root.querySelector('.influencer-carousel__arrow--prev');
    var nextBtn = root.querySelector('.influencer-carousel__arrow--next');

    if (cards.length <= 1) {
      if (prevBtn) prevBtn.setAttribute('hidden', 'hidden');
      if (nextBtn) nextBtn.setAttribute('hidden', 'hidden');
    } else {
      if (prevBtn) prevBtn.addEventListener('click', function () { go(state, -1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { go(state, 1); });
    }

    if (state.track) {
      state.track.addEventListener('click', function (e) {
        if (e.target.closest && e.target.closest('a')) {
          return;
        }
        var cardEl = e.target.closest ? e.target.closest('.influencer-card') : null;
        if (!cardEl) {
          return;
        }
        var mediaHit = e.target.closest ? e.target.closest('.influencer-card__media') : null;
        if (mediaHit) {
          togglePlay(state, cardEl);
        }
      });
    }

    cards.forEach(function (card) {
      var v = getVideo(card);
      if (v) {
        v.addEventListener('pause', function () {
          card.classList.remove('is-playing');
        });
        v.addEventListener('play', function () {
          card.classList.add('is-playing');
        });
      }
    });

    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') go(state, -1);
      if (e.key === 'ArrowRight') go(state, 1);
    });

    if (state.viewport && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
              var idx = parseInt(entry.target.getAttribute('data-index'), 10) || 0;
              setCurrent(state, idx);
            }
          });
        },
        { root: state.viewport, threshold: [0.6] }
      );
      cards.forEach(function (card) {
        observer.observe(card);
      });
    }

    instances[rootId] = state;

    if (window.Shopify && Shopify.designMode) {
      document.addEventListener('shopify:block:select', function (evt) {
        var blockEl = evt.target.closest ? evt.target.closest('.influencer-card') : null;
        if (blockEl && root.contains(blockEl)) {
          blockEl.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        }
      });
    }
  }

  window.InfluencerCarousel = { init: init };
})();
